import type {
  SearchResultItem,
  SpatialLayer,
} from '../../GlobalMapSearch.types';
import { runSpatialAttributeSearch } from '../spatial/spatialAttributeSearch';

interface RunDynamicLayerSearchArgs {
  text: string;
  layers: SpatialLayer[];
  collected: SearchResultItem[];
  flush: () => void;
}

/**
 * Generic fuzzy search across active dynamic spatial layers (Eagle Eye,
 * Avive AED requests, etc.). Axon is excluded — it has its own specialized
 * pipeline in `axonSearch.ts` driven by `selectAxon`.
 */
export function runDynamicLayerSearch({
  text,
  layers,
  collected,
  flush,
}: RunDynamicLayerSearchArgs): void {
  runSpatialAttributeSearch({
    text,
    source: 'dynamic',
    layers,
    collected,
    flush,
  });
}
